import {
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    Checkbox,
    Chip,
    CircularProgress,
    Collapse,
    Divider,
    FormControlLabel,
    FormGroup,
    Grid,
    InputAdornment,
    MenuItem,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    TextField,
    Tooltip,
    Typography
} from '@material-ui/core';
import { green, purple, red, yellow } from '@material-ui/core/colors';
import { ExpandMore, Print, Search, Visibility } from '@material-ui/icons';
import moment from 'moment';
import { Fragment, useContext, useEffect, useState } from 'react';
import { useNotify, useRedirect } from 'react-admin';
import { Spacer } from '../../../components/spacer';
import dataProvider from '../../../providers/data-provider';
// import ActivityDialog from './activity-dialog';
import { AppContext } from '../../../providers/app-context-provider/app.context';
import { ActivityFinishDialog } from './activity-finish-dialog';
import { ReportDialog } from './report-dialog';

const LoadingBox = () => (
    <Box display="flex" justifyContent="center" alignItems="center" height="100%">
        <CircularProgress />
    </Box>
);

const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return dateString;
    return date.toLocaleDateString('pt-BR');
};

const getUserNames = (users) => {
    if (!users?.length) return '-';
    return users
        .map((u) => u?.user?.name)
        .sort()
        .join(' • ');
};

const getStatusChip = (start_at, deadline, effective_deadline, evaluated, finished) => {
    let status;
    if (finished) {
        status = 'completedSuccess'
    } else {
        if (moment().isBefore(moment(start_at))) {
            status = 'notStarted'
        } else if (moment().isBefore(moment(deadline))) {
            status = 'inProgress'
        } else if (moment().isBetween(moment(deadline), moment(effective_deadline))) {
            status = 'completedAlert'
        } else if (moment().isAfter(effective_deadline)) {
            status = 'completedFailure'
        }
    }

    if (evaluated) {
        return <Chip label="Corrigido" color="secondary" size="small" style={{ backgroundColor: '#44bb33' }} />
    } else {
        switch (status) {
            case 'notStarted':
                return <Chip label="Não iniciado" size="small" style={{ backgroundColor: '#a5a5a5' }} />
            case 'inProgress':
            default:
                return <Chip label="Em andamento" size="small" style={{ backgroundColor: '#1b63cf' }} />
            case 'completedSuccess':
                return <Chip label="Finalizado" size="small" style={{ backgroundColor: '#44bb33' }} />
            case 'completedAlert':
                return <Chip label="Prazo do aluno vencido" size="small" style={{ backgroundColor: '#b3a728ff' }} />
            case 'completedFailure':
                return <Chip label="Prazo do gestor vencido" size="small" style={{ backgroundColor: '#bb3333' }} />
        }
    }
};

const getActivityWorkload = (workload) => {
    if (!workload) return '-'
    if (workload === 'nc') return "Não cumpriu"
    else if (workload === 'cp') return "Cumpriu parcialmente"
    else if (workload === 'ct') return "Cumpriu totalmente"
    else return workload;
}

const OfficeTeacherDashboard = () => {

    const redirect = useRedirect()
    const notify = useNotify()

    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [loaded, setLoaded] = useState(false);

    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [reloadFlag, setReloadFlag] = useState(0);

    const [selected, setSelected] = useState({
        process: null,
        activity: null,
    });

    const [reportDialogOpen, setReportDialogOpen] = useState(false)
    const [reportData, setReportData] = useState(null)
    const [reportType,] = useState(null)

    const [expandedprocessId, setExpandedprocessId] = useState(null);
    const [expandedactivities, setExpandedactivities] = useState({});

    // const [dialogCompletionOpen, setDialogCompletionOpen] = useState(false)
    const [dialogFinishOpen, setDialogFinishOpen] = useState(false)

    const [filter, setFilter] = useState({
        active: true,
        open_activities: true,
        urgency: 'overdue+soon',
    });

    const [uiFilters, setUiFilters] = useState({
        search: '',
        scope: 'active',
        urgency: 'overdue+soon',
        openActivities: true,
        pendingEvaluation: false,
    });

    const context = useContext(AppContext)

    useEffect(() => {
        (async () => {
            try {
                setLoading(true);
                setLoaded(false);

                const resp = await dataProvider.get(
                    'teacher',
                    'process-dashboard',
                    {
                        filter: JSON.stringify(filter),
                        page,
                        limit: perPage,
                        sort: 'process.created_at',
                        order: 'DESC'
                    }
                );
                setData(resp.data.data || []);
                setTotal(resp.data.total || 0);
            } catch (e) {
                console.error('Erro ao carregar atividades do professor: ', e)
                notify('Erro ao carregar atividades do professor.', 'error');
            } finally {
                setLoading(false);
                setLoaded(true);
            }
        })();
    }, [filter, page, perPage, reloadFlag, notify, context]);

    const handleReportDialogClose = () => { setReportDialogOpen(false) }

    const toggleprocessExpanded = (processId) => {
        setExpandedprocessId((prev) => (prev === processId ? null : processId));
        setExpandedactivities({});
    };

    const toggleactivityExpanded = (processId, activityId) => {
        setExpandedactivities((prev) => ({
            ...prev,
            [processId]: prev[processId] === activityId ? null : activityId,
        }));
    };

    const isactivityExpanded = (processId, activityId) => {
        return expandedactivities[processId] === activityId;
    };

    const handleEvaluateActivity = (activity) => {
        redirect(`activities/${activity.id}`)
    };

    const handleOpenFinish = (process, activity) => {
        setSelected({ process, activity })
        setDialogFinishOpen(true)
    }

    /*const handleCloseCompletion = () => {
        setSelected({ process: null, activity: null });
        setDialogCompletionOpen(false)
    };*/

    const handleCloseFinish = () => {
        setSelected({ process: null, activity: null });
        setDialogFinishOpen(false)
    };


    const handleChangePage = (_event, newPage) => {
        setPage(newPage + 1);
    };

    const handleChangeRowsPerPage = (event) => {
        const newPerPage = parseInt(event.target.value, 10);
        setPerPage(newPerPage);
        setPage(1);
    };

    const handleUiFilterChange = (field) => (event) => {
        setUiFilters((prev) => ({
            ...prev,
            [field]: event.target.value,
        }));
    };

    const handleToggleFilter = (field) => () => {
        setUiFilters((prev) => ({
            ...prev,
            [field]: !prev[field],
        }));
    };

    const handleApplyFilters = () => {
        const f = {};

        if (uiFilters.scope === 'active') {
            f.active = true;
        } else if (uiFilters.scope === 'inactive') {
            f.active = false;
        }

        if (uiFilters.search) {
            f.search = uiFilters.search;
        }

        if (uiFilters.openActivities) {
            f.open_activities = true;
        }

        if (uiFilters.urgency !== 'all') {
            f.urgency = uiFilters.urgency;
        }

        if (uiFilters.pendingEvaluation) {
            f.pending_evaluation = true;
        }

        setFilter(f);
        setPage(1);
    };


    const redirectToDashboard = (id) => {
        redirect(`/process-dashboard/${id}`)
    }

    const handleClearFilters = () => {
        setUiFilters({
            search: '',
            scope: 'active',
            urgency: 'overdue+soon',
            openActivities: true,
            pendingEvaluation: false,
        });
        setFilter({
            active: true,
            open_activities: true,
            urgency: 'overdue+soon',
        });
        setPage(1);
    };

    const generateGradesReport = (id, type, analytic) => {
        const selected = data.find(el => el.id === id)
        setReportData({ data: selected, type, analytic })
        setReportDialogOpen(true)
    }

    const getDeadlineDifferenceInDays = (activity) => {
        const dateStr = activity.effective_deadline || activity.deadline;
        if (!dateStr) return null;

        const today = new Date();
        const todayMidnight = new Date(
            today.getFullYear(),
            today.getMonth(),
            today.getDate(),
        );

        const deadline = new Date(dateStr);
        if (Number.isNaN(deadline.getTime())) return null;

        const diffMs = deadline.getTime() - todayMidnight.getTime();
        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

        return diffDays;
    };

    const getActivityDeadlineChipInfo = (activity) => {
        if (activity.finished) {
            return {
                label: 'Movimentação finalizada',
                color: green[500],
                tooltip: 'Movimentação finalizada',
                order: 9999,
            }
        }

        const diff = getDeadlineDifferenceInDays(activity);
        if (diff === null) {
            return {
                label: 'Sem prazo',
                color: undefined,
                tooltip: 'Não há prazo definido para esta atividade',
                order: 9999,
            };
        }

        if (diff >= 5) {
            return {
                label: '5 dias ou mais',
                color: green[500],
                tooltip: '5 dias ou mais até o prazo',
                order: 3,
            };
        }

        if (diff >= 2 && diff <= 4) {
            return {
                label: '2 a 4 dias',
                color: yellow[700],
                tooltip: '2 a 4 dias de prazo',
                order: 2,
            };
        }

        if (diff >= 0 && diff <= 1) {
            return {
                label: 'Até 1 dia',
                color: red[500],
                tooltip: 'Menos de 1 dia para o prazo',
                order: 1,
            };
        }

        return {
            label: 'Prazo vencido',
            color: purple[500],
            tooltip: 'Prazo vencido',
            order: 0,
        };
    };

    const getMostUrgentActivity = (process) => {
        if (!process.activities || process.activities.length === 0) return null;

        const openActivities = process.activities.filter((a) => a.finished === false);

        if (openActivities.length === 0) return null;

        // ordena por situação (vencido > curto > médio > longo) e depois por data
        const sorted = [...openActivities].sort((a, b) => {
            const infoA = getActivityDeadlineChipInfo(a);
            const infoB = getActivityDeadlineChipInfo(b);

            if (infoA.order !== infoB.order) {
                return infoA.order - infoB.order;
            }

            const diffA = getDeadlineDifferenceInDays(a) ?? 9999;
            const diffB = getDeadlineDifferenceInDays(b) ?? 9999;

            return diffA - diffB;
        });

        return sorted[0];
    };


    const hasProcesses = data && data.length > 0;

    if (loading && !loaded) {
        return <LoadingBox />;
    }

    return (
        <Box p={3}>
            <Typography variant='h4'>{`Dashboard do NPJ - ${context.profile.name}`}</Typography>
            <Divider />

            <Box mb={3}>
                <Typography variant='h6' style={{ marginTop: '16px', marginLeft: '8px' }}>{`Filtros`}</Typography>
                <Grid container spacing={2} alignItems="flex-end">
                    <Grid item xs={12} sm={6}>
                        <TextField
                            select
                            fullWidth
                            label="Situação do processo"
                            value={uiFilters.scope}
                            onChange={handleUiFilterChange('scope')}
                            variant="outlined"
                            margin="dense"
                        >
                            <MenuItem value="active">
                                Em aberto
                            </MenuItem>
                            <MenuItem value="inactive">
                                Arquivados
                            </MenuItem>
                            <MenuItem value="all">
                                Em aberto e arquivados
                            </MenuItem>
                        </TextField>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={uiFilters.openActivities}
                                        onChange={handleToggleFilter('openActivities')}
                                    />
                                }
                                label="Apenas com movimentações em aberto"
                            />
                        </FormGroup>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            select
                            fullWidth
                            label="Pendências de prazo"
                            value={uiFilters.urgency}
                            onChange={handleUiFilterChange('urgency')}
                            variant="outlined"
                            margin="dense"
                        >
                            <MenuItem value="overdue+soon">
                                Vencidos + Vencendo em 7 dias
                            </MenuItem>
                            <MenuItem value="all">
                                Todos
                            </MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={uiFilters.pendingEvaluation}
                                        onChange={handleToggleFilter('pendingEvaluation')}
                                    />
                                }
                                label="Apenas com movimentações pendentes de avaliação"
                            />
                        </FormGroup>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Buscar"
                            placeholder="Número do processo, ou nome do cliente, gestor ou aluno"
                            value={uiFilters.search}
                            onChange={handleUiFilterChange('search')}
                            variant="outlined"
                            margin="dense"
                            InputProps={{ startAdornment: <InputAdornment><Search /></InputAdornment> }}
                        />
                    </Grid>


                    <Grid item xs={12}>
                        <Box display="flex" justifyContent="flex-end" mt={1}>
                            <Button
                                onClick={handleClearFilters}
                                style={{ marginRight: 8 }}
                            >
                                Limpar filtros
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleApplyFilters}
                            >
                                Aplicar filtros
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Box>

            <Box style={{ marginBottom: '16px' }}>
                {!hasProcesses && (
                    <Typography variant="body1">
                        Nenhuma atividade encontrada para este professor.
                    </Typography>
                )}
                <Divider />
            </Box>
            <Grid container spacing={2}>
                {data.map((process) => {
                    const mostUrgentActivity = getMostUrgentActivity(process);
                    const mostUrgentChip = mostUrgentActivity ? getActivityDeadlineChipInfo(mostUrgentActivity) : null;
                    return (
                        <Grid item xs={12} key={process.id}>
                            <Card>
                                <CardHeader
                                    title={<>
                                        {mostUrgentChip && (
                                            <Tooltip title={mostUrgentChip.tooltip}>
                                                <Chip
                                                    label={mostUrgentChip.label}
                                                    size="small"
                                                    style={{
                                                        backgroundColor: mostUrgentChip.color,
                                                        color: '#fff',
                                                        marginInline: '8px'
                                                    }}
                                                />
                                            </Tooltip>
                                        )}
                                        <Typography component={'span'} variant='h6'>{`${process.alias} • ${process.client.name}`}</Typography>
                                    </>}
                                    subheader={<Grid container>
                                        <Typography>{`Data de criação: ${formatDate(process.created_at)}`}</Typography>
                                        <Chip size='small' style={{ marginInline: '16px' }} label={process.active ? "Em aberto" : "Arquivado"} color={process.active ? "primary" : "default"} />
                                    </Grid>}
                                    action={
                                        <Fragment>
                                            <Button
                                                size='small'
                                                endIcon={<Visibility />}
                                                variant='outlined'
                                                children={`Dashboard`}
                                                onClick={() => redirectToDashboard(process.id)}
                                                style={{ marginInline: 8 }}
                                            />
                                            <Button
                                                size="small"
                                                endIcon={<Print />}
                                                variant='outlined'
                                                children={`Relatório gerencial`}
                                                onClick={() => generateGradesReport(process.id, 'manager-report', false)}
                                                style={{ marginInline: 8 }}
                                            />
                                            <Button
                                                size="small"
                                                endIcon={<Print />}
                                                variant='outlined'
                                                children={`Relatório acadêmico`}
                                                onClick={() => generateGradesReport(process.id, 'academic-report', false)}
                                                style={{ marginInline: 8 }}
                                            />
                                            <Button
                                                onClick={() => toggleprocessExpanded(process.id)}
                                                aria-expanded={expandedprocessId === process.id}
                                                aria-label="Mostrar tarefas"
                                                endIcon={<ExpandMore
                                                    style={{
                                                        transform: expandedprocessId === process.id ? 'rotate(180deg)' : 'rotate(0deg)',
                                                        transition: 'transform 0.2s',
                                                    }}
                                                />}
                                                children={expandedprocessId === process.id ? `Ocultar` : `Exibir`}
                                            />
                                        </Fragment>
                                    }
                                />
                                <Collapse in={expandedprocessId === process.id} timeout="auto" unmountOnExit>
                                    <CardContent>
                                        {process.activities && process.activities.length > 0 ? (
                                            process.activities.sort((a, b) => new Date(a.start_at) - new Date(b.start_at)).map((activity) => {
                                                const chipInfo = getActivityDeadlineChipInfo(activity);
                                                return (
                                                    <Fragment key={activity.id}>
                                                        <Box mb={1} mt={2} display="flex" justifyContent="flex-start" alignItems="center">
                                                            <Box>
                                                                <Chip
                                                                    label={chipInfo.label}
                                                                    size="small"
                                                                    style={{
                                                                        backgroundColor: chipInfo.color,
                                                                        color: '#fff',
                                                                        marginInline: '8px'
                                                                    }}
                                                                />
                                                            </Box>
                                                            <Box>
                                                                <Typography variant="subtitle1">
                                                                    {activity.type.name}
                                                                </Typography>
                                                                <Typography variant="body2" color="textSecondary">
                                                                    {/*`Início: ${formatDate(activity.start_at)} • Prazo alunos: ${formatDate(activity.deadline)} • Prazo final: ${formatDate(activity.effective_deadline)}`*/}
                                                                    {`Prazo alunos: ${formatDate(activity.deadline)} • Prazo final: ${formatDate(activity.effective_deadline)}`}
                                                                </Typography>
                                                            </Box>
                                                            <Spacer />
                                                            <Box display="flex" alignItems="center">
                                                                {(activity.requires_grade && activity.type.workload_type !== 'C') && (
                                                                    <Chip
                                                                        label={`Valor: ${activity.type.reference_workload} ${activity.type.reference_workload === 'G' ? `pontos` : `horas`}`}
                                                                        size="small"
                                                                        style={{ marginInline: 8 }}
                                                                    />
                                                                )}
                                                                <Button
                                                                    size="small"
                                                                    onClick={() => toggleactivityExpanded(process.id, activity.id)}
                                                                    endIcon={<ExpandMore
                                                                        style={{
                                                                            transform: isactivityExpanded(process.id, activity.id) ? 'rotate(180deg)' : 'rotate(0deg)',
                                                                            transition: 'transform 0.2s',
                                                                        }}
                                                                    />}
                                                                    style={{ marginInline: 8 }}
                                                                >
                                                                    {isactivityExpanded(process.id, activity.id) ? 'Ocultar entregas' : 'Ver entregas'}
                                                                </Button>
                                                            </Box>
                                                        </Box>
                                                        <Collapse in={isactivityExpanded(process.id, activity.id)} timeout="auto" unmountOnExit>
                                                            <Table size="small">
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell>Status</TableCell>
                                                                        <TableCell>Membros</TableCell>
                                                                        <TableCell>Nota</TableCell>
                                                                        <TableCell align="right">Ações</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    <TableRow key={activity.id} hover>
                                                                        <TableCell>
                                                                            {getStatusChip(activity.start_at, activity.deadline, activity.effective_deadline, activity.evaluated, activity.finished)}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            {getUserNames(activity?.students)}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            {getActivityWorkload(activity.workload)}
                                                                        </TableCell>
                                                                        <TableCell align="right">
                                                                            {(context?.profile.name !== 'Advogado' && context?.profile.name !== 'Advogado geral') &&
                                                                                <Button
                                                                                    size="small"
                                                                                    color="primary"
                                                                                    variant='contained'
                                                                                    onClick={() => handleEvaluateActivity(activity)}
                                                                                >
                                                                                    {activity.evaluated ? 'Editar correção' : 'Corrigir'}
                                                                                </Button>
                                                                            }
                                                                            {context?.profile.name !== 'Professor' &&
                                                                                <Button
                                                                                    style={{ marginLeft: "4px" }}
                                                                                    size='small'
                                                                                    color='primary'
                                                                                    variant='contained'
                                                                                    onClick={() => handleOpenFinish(process, activity)}
                                                                                >
                                                                                    {activity.finished ? 'Reativar' : 'Encerrar'}
                                                                                </Button>
                                                                            }
                                                                        </TableCell>
                                                                    </TableRow>
                                                                </TableBody>
                                                            </Table>
                                                        </Collapse>
                                                    </Fragment>
                                                )
                                            })
                                        ) : (
                                            <Typography variant="body2" color="textSecondary">
                                                Nenhuma tarefa cadastrada para esta atividade.
                                            </Typography>
                                        )}
                                    </CardContent>
                                </Collapse>
                            </Card>
                        </Grid>
                    )
                })}
            </Grid>

            {
                hasProcesses && (
                    <Paper>
                        <Box mt={2} display="flex" justifyContent="flex-end">
                            <TablePagination
                                component="div"
                                count={total}
                                page={page - 1}
                                onPageChange={handleChangePage}
                                rowsPerPage={perPage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                rowsPerPageOptions={[5, 10, 20, 50]}
                                labelRowsPerPage="Itens por página"
                            />
                        </Box>
                    </Paper>
                )
            }

            {/*
                <ActivityDialog
                    open={dialogCompletionOpen}
                    onClose={handleCloseCompletion}
                    activity={selected.activity}
                    process={selected.process}
                    onEvaluated={() => setReloadFlag(f => f + 1)}
                />
            */}

            <ActivityFinishDialog
                open={dialogFinishOpen}
                onClose={handleCloseFinish}
                activity={selected.activity}
                process={selected.process}
                onFinished={() => setReloadFlag(f => f + 1)}
            />

            <ReportDialog
                open={reportDialogOpen}
                onClose={handleReportDialogClose}
                data={reportData}
                type={{ id: 'manager-report', type: reportType }}
            />


            {
                loading && loaded && (
                    <Box mt={1}>
                        <Typography variant="caption" color="textSecondary">
                            Atualizando atividades...
                        </Typography>
                    </Box>
                )
            }
        </Box>
    );
};

export default OfficeTeacherDashboard;
